import React, { useEffect } from 'react';
import { useSSRExperimentContext } from '../../contexts/ExperimentationContext/context';
import { isTestAAExperiment } from '../../experimentation/experiments';

const experimentName = 'test_aa_ssr';

export const TestAaSsr = () => {
    const ssrExperimentation = useSSRExperimentContext();

    const enabled =
        ssrExperimentation.isSSRExperimentationEnabled &&
        ssrExperimentation.experiments[experimentName];

    useEffect(
        () => {
            if (!ssrExperimentation.isSSRExperimentationEnabled) {
                return;
            }

            const isVariant = isTestAAExperiment();

            if (isVariant !== enabled) {
                console.error(
                    'Mismatch between SSR and Client side variant for experiment',
                    experimentName,
                );
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    if (enabled) {
        return (
            <span data-testid="aa-experiment-enabled" data-enabled={enabled} />
        );
    }

    return null;
};
